const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} pagati · {{freeQuantity}} × gratis',
  all_free: '{{freeQuantity}} × gratis',
};

export default OfferLineBreakdown;
